import * as signalR from "@microsoft/signalr";

let connection = null;

export function tryStartSignalRConnection(userUnassignedHandler) {
  const tokenData = JSON.parse(localStorage.getItem("tokenData"));

  if ((connection && connection.state === signalR.HubConnectionState.Connected) || !tokenData?.accessToken) {
    return connection;
  }

  connection = new signalR.HubConnectionBuilder()
    .withUrl(`${window.location.origin}/notification-hub`, {
      accessTokenFactory: () => tokenData?.accessToken,
      transport: signalR.HttpTransportType.WebSockets
    })
    .withAutomaticReconnect()
    .build();

  connection.on("UnassignedFromReport", (reportId) => userUnassignedHandler(reportId));

  connection.start()
    .then(() => {
      console.log("SignalR connected");
    })
    .catch(err => {
      console.error("SignalR connection error:", err);
    });

  return connection;
}

export function tryStopSignalRConnection() {
  if (connection) {
    console.log("SignalR disconnected")
    connection.stop();
  }
}